import { REDIRECT_URL, SSO_CLIENT_ID, SSO_TENANT_URL } from "utility/constants";
export const msalConfig = {
  auth: {
    clientId: SSO_CLIENT_ID,
    validateAuthority: true,
    authority: SSO_TENANT_URL,
    redirectUri: REDIRECT_URL,
  },
  cache: {
    cacheLocation: "sessionStorage", 
    storeAuthStateInCookie: false, 
    secureCookies: false
  },
};

// Add scopes here for ID token to be used at Microsoft identity platform endpoints.
export const loginRequest = {
  scopes: [`${SSO_CLIENT_ID}/.default`]
};

// One-shot guard so the auth-error screen redirects to Azure at most once per
// failed session, preventing an infinite redirect loop on a deterministic error.
export const AUTH_REDIRECT_ATTEMPT_KEY = "tdsp_auth_redirect_attempted";

export const graphRequest = {
  scopes: ["User.Read"]
};
